import React from 'react';
import './styles/CTAButton.css';

function CTAButton({ text, onClick, type = 'button', disabled = false }) {
  return (
    <button type={type} className="cta-button" onClick={onClick} disabled={disabled}>
      <span className="cta-text">{text}</span>
      <span className="cta-icon">→</span>
    </button>
  );
}

export default CTAButton;
